<template>
  <span
    class="hidden items-center rounded-md bg-gpx_gray-200 px-2 py-px text-[10px] text-white md:flex"
  >
    Tracks loading...
  </span>
</template>
